import axios from 'axios'
import { useToast } from 'vuestic-ui'
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL
const { init } = useToast()
import { useAuthStore } from '../stores/auth'
const axiosService = axios.create({
  baseURL: apiBaseUrl,
  timeout: 20000,
  withCredentials: false,
})

// Request interceptors
axiosService.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    const token = authStore.token || localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

// Response interceptors
axiosService.interceptors.response.use(
  (response) => {
    const body = response.data
    if (!body.error) {
      return body
    }
    init({ message: body.error.message, color: 'danger' })
    return Promise.reject(body.error)
  },
  (error) => {
    const body = error.response
    if (body && body.data) {
      init({ message: body.data.error.message, color: 'danger' })
      return Promise.reject(body.data.error)
    } else {
      return Promise.reject(error)
    }
  },
)

export default axiosService
